module.exports = __webpack_public_path__ + "src/assets/img/smoke_six.2243ad20.svg";